import React from 'react';
import Page1 from "./Page1";
import Page2 from "./Page2";
import Page3 from "./Page3";
import Page4 from "./Page4";
import Page5 from "./Page5";
import Page6 from "./Page6";
import {scrollToTop} from "../../../../../../libs/helpers";

export default class HowToFormulateActionPlans extends React.Component {

    state = {
        currentPage: 'Page1'
    }

    pages = {
        Page1: Page1,
        Page2: Page2,
        Page3: Page3,
        Page4: Page4,
        Page5: Page5,
        Page6: Page6
    }

    handleChangePage = (currentPage) => _ => {
        this.setState({
            currentPage
        });

        scrollToTop();
    }

    render() {

        const Page = this.pages[this.state.currentPage] || 'Page1';

        return (
            <Page handleChangePage={this.handleChangePage}
                  handleChangeMainPage={this.props.handleChangePage}
                  incompletePage={!this.props.pagesData?.['HowToFormulateActionPlans']?.status}
                  savePageStatus={this.props.savePageStatus}/>
        );
    }
}